module.exports = __webpack_public_path__ + "img/h-page4-34.2e2ccf84.png";